Object.defineProperty(exports, '__esModule', { value: true });

var pure_component = require('./pure/component.js');
var component = require('./component.js');

var Amount = component.Amount;
Amount.Pure = pure_component.PureAmount;

exports.Amount = Amount;
